import { grey } from '@material-ui/core/colors';
import { makeStyles, useTheme } from '@material-ui/core/styles';

export const Theme = useTheme;

type PictureStyleProps = {
	clickable: boolean;
};

export const useStyles = makeStyles(theme => {
	return {
		pictureBox: {
			position: 'relative',
			width: '100%',
			height: '100%',
			minHeight: 0,
			cursor: (props: PictureStyleProps) => (props.clickable ? 'pointer' : null)
		},
		previewLabel: {
			overflow: 'hidden',
			width: '100%',
			height: 30
		},
		label: {
			color: grey[600],
			fontSize: 13,
			fontWeight: 500
		}
	};
});
